import { render, staticRenderFns } from "./AddProductDialog.vue?vue&type=template&id=9391fcc6&scoped=true"
import script from "./AddProductDialog.vue?vue&type=script&lang=js"
export * from "./AddProductDialog.vue?vue&type=script&lang=js"
import style0 from "./AddProductDialog.vue?vue&type=style&index=0&id=9391fcc6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9391fcc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9391fcc6')) {
      api.createRecord('9391fcc6', component.options)
    } else {
      api.reload('9391fcc6', component.options)
    }
    module.hot.accept("./AddProductDialog.vue?vue&type=template&id=9391fcc6&scoped=true", function () {
      api.rerender('9391fcc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialog/AddProductDialog.vue"
export default component.exports